import React from 'react'
import { IconWrapper } from '../IconWrapper'
import type { IconWrapperProps } from '../IconWrapper'

export const AudioIcon = React.forwardRef<SVGSVGElement, IconWrapperProps>(
  (props, forwardedRef) => {
    return (
      <IconWrapper {...props}>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
          ref={forwardedRef}
        >
          <path
            d="M14 19.4883L7.09225 14.8148H4V9.16302H7.02416L14 4.50391V19.4883ZM3.40704 7.16302H6.41768L13.7788 2.2466C14.7105 1.62432 16 2.25143 16 3.32683V20.6732C16 21.7522 14.7026 22.3785 13.7718 21.7487L6.47924 16.8148H3.40704C2.62995 16.8148 2 16.2218 2 15.4903V8.48753C2 7.75602 2.62995 7.16302 3.40704 7.16302ZM18.465 5.63783C18.8172 5.28557 19.3919 5.28315 19.7108 5.66588C21.1404 7.38164 22 9.58949 22 12C22 14.4118 21.1395 16.6207 19.7085 18.3369C19.3908 18.718 18.8184 18.7156 18.4675 18.3647C18.1174 18.0146 18.121 17.45 18.4296 17.0629C19.535 15.6762 20.2005 13.9172 20.2005 12C20.2005 10.0862 19.5374 8.33 18.4298 6.95009C18.1173 6.56072 18.1119 5.99087 18.465 5.63783ZM17.0075 8.36448C17.2088 8.16318 17.5373 8.1618 17.7195 8.3805C18.5364 9.36094 19.0275 10.6226 19.0275 12C19.0275 13.3782 18.5359 14.6404 17.7182 15.6211C17.5366 15.8388 17.2095 15.8375 17.009 15.637C16.8089 15.4369 16.811 15.1143 16.9873 14.8931C17.619 14.1007 17.9993 13.0955 17.9993 12C17.9993 10.9064 17.6203 9.90286 16.9875 9.11434C16.8089 8.89184 16.8058 8.56621 17.0075 8.36448Z"
            fill="#222"
            fillRule="evenodd"
            clipRule="evenodd"
          />
        </svg>
      </IconWrapper>
    )
  },
)
